import { getItemsJoinedByPipe } from '../../utils';

import { type FormatItemForDataLayerProps } from './types';

export function formatItemForDataLayer(item: FormatItemForDataLayerProps) {
  const category = item.categoryTree ? item.categoryTree.split('/') : [];
  const variants = getItemsJoinedByPipe(item.variants ?? []);

  return {
    id: item.id,
    bind_id: item.bind_id || undefined,
    name: item.name,
    type: item.type,
    price: item.price,
    brand: item.brand,
    discount: item.discount || undefined,
    discount_type: item.discountType || undefined,
    seller: item.seller,
    quantity: item.quantity,
    category: category[0] || undefined,
    category2: category[1] || undefined,
    category3: category[2] || undefined,
    category4: category[3] || undefined,
    category5: category[4] || undefined,
    variant: variants,
    box_unit: item.box?.unit || undefined,
    price_box: item.box?.price || undefined,
    quantity_box: item.box?.quantity || undefined,
  };
}
